import get from "lodash/get";
import moment from "moment";

import {
  getBasisType,
  getFile,
  getFunction,
  getFunctionUser,
  getMultiName,
  getNameAndLink,
  getOrganization,
  getReestrProject,
  getTask, MapLexData, MapLexDataList,
} from "helpers/mappers";

export const FunctionRegister = (item) => {
  const createdAt = moment(get(item, "created_at"), "YYYY-MM-DD HH:mm:SS");
  const updatedAt = moment(get(item, "updated_at"), "YYYY-MM-DD HH:mm:SS");

  return {
    id: get(item, "id") || "",
    organization: getOrganization(get(item, "organization_response")),
    function: getFunction(get(item, "function_name_response")),
    level: get(item, "function_name_response.level") || "",
    functionGroup: get(item, "function_group") || "",
    basisDate: get(item, "basis_date")
      ? moment(get(item, "basis_date"), "YYYY-MM-DD").format("DD.MM.YYYY")
      : "",
    basisType: getBasisType(get(item, "basis_type_response")),
    basisNumber: get(item, "basis_number") || "",
    basisName: getMultiName(get(item, "basis_name")),
    functionDegree: (get(item, "degrees") || []).map((degree) =>
      get(degree, "function_degree"),
    ),
    departmentName: get(item, "department_name") || "",
    mechanism: getMultiName(get(item, "mechanism")),
    mechanismBasisDate: get(item, "mechanism_basis_date")
      ? moment(get(item, "mechanism_basis_date"), "YYYY-MM-DD").format(
          "DD.MM.YYYY",
        )
      : "",
    mechanismBasisType: getBasisType(
      get(item, "mechanism_basis_type_response"),
    ),
    mechanismBasisNumber: get(item, "mechanism_basis_number") || "",
    mechanismBasisName: getMultiName(get(item, "mechanism_basis_name")),
    dedicatedEmployer: get(item, "dedicated_employer") || "",
    source: get(item, "source") || "",
    fund: get(item, "fund") || "",
    currency: get(item, "currency") || "",
    percentage: get(item, "percentage") || "",
    personal: get(item, "personal") || false,
    task: getTask(get(item, "task_response")),
    activityType: get(item, "activity_type") || "",
    digitizationStatus: get(item, "digitization_status") || "",
    functionUsers: (get(item, "function_users") || []).map((item) =>
      getFunctionUser(item),
    ),
    reestrProjects: (get(item, "reestr_projects") || []).map((item) =>
      getReestrProject(item),
    ),
    presentationStatus: (get(item, "presentation_status") || []).map((item) =>
      getNameAndLink(item),
    ),
    otherSystem: (get(item, "other_system") || []).map((item) =>
      getNameAndLink(item),
    ),
    createdAt:
      get(item, "created_at") && createdAt.isValid()
        ? createdAt.format("DD.MM.YYYY")
        : "",
    updatedAt:
      get(item, "updated_at") && updatedAt.isValid()
        ? updatedAt.format("DD.MM.YYYY")
        : "",
    stages: get(item, "function_stage_responses") || [],
    register_requirements: get(item, "register_requirements") || [],
    government_services: get(item, "government_services") || [],
  };
};

export const FunctionNames = (item) => {
  return {
    name: getMultiName(get(item, "name")),
    code: get(item, "code"),
    organizations: (get(item, "organizations") || []).map((o) => ({
      name: getMultiName(get(o, "name")),
    })),
    functionGroup: get(item, "function_group"),
    link: get(item, "link"),
    level: get(item, "level"),
  };
};

export const FunctionNamesByOrg = (item) => {
  return {
    id: get(item, "id"),
    name: getMultiName(get(item, "name")),
    file: getFile(get(item, "file_response")),
    count: get(item, "count"),
  };
};

export const FunctionNamesByLevel = (item) => {
  return {
    level: get(item, "level"),
    count: get(item, "count"),
  };
};

export const FunctionTasks = (item) => {
  return {
    name: get(item, "name"),
    description: get(item, "description"),
    organization: {
      id: get(item, "organization.id"),
      name: getMultiName(get(item, "organization.name")),
    },
    mainLexData: MapLexData(get(item, 'main_lex_data')),
    organizationId: get(item, 'organization.id'),
    type: get(item, 'type'),
    canBe: get(item, 'can_be'),
  };
};

export const FunctionTasksByOrg = (item) => {
  return {
    id: get(item, "id"),
    name: getMultiName(get(item, "name")),
    file: getFile(get(item, "file_response")),
    count: get(item, "count"),
  };
};

export const StageSteps = (item) => {
  return {
    id: get(item, "id"),
    name: get(item, "name"),
    mechanism_id: get(item, "mechanism_id"),
    organization_id: get(item, "organization_id"),
    function_id: get(item, "function_id"),
    classifier_id: get(item, "classifier_id"),
    order_number: get(item, "order_number"),
    stage_status: get(item, "stage_status"),
    steps: (get(item, "steps") || []).map((step) => ({
      id: get(step, "id"),
      name: get(step, "name"),
      description: get(step, "description"),
      stage: {
        id: get(step, "stage.id"),
        name: get(step, "stage.name"),
      },
      order_number: get(step, "order_number"),
      position: {
        id: get(step, "position.id"),
        name: get(step, "position.name"),
      },
      department: {
        id: get(step, "department.id"),
        name: get(step, "department.name"),
      },
      digitizationStatus: get(step, "digitization_status"),
      paperConsumption: get(step, "paper_consumption"),
      timeConsumption: get(step, "time_consumption"),
    })),
  };
};
